module.exports = __webpack_public_path__ + "assets/img/6d6fc8290f33ee3a2490210643d09058.svg";